// extracted by mini-css-extract-plugin
export default {"redirect":"AuthRedirectPage_redirect__40XRi","text":"AuthRedirectPage_text__y6XLG"};